import { render } from "./TrustWecobi.vue?vue&type=template&id=a4047d7c&scoped=true"
import script from "./TrustWecobi.vue?vue&type=script&lang=js"
export * from "./TrustWecobi.vue?vue&type=script&lang=js"

import "./TrustWecobi.vue?vue&type=style&index=0&id=a4047d7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4047d7c"]])

export default __exports__